import { APP_LOCALES, DEFAULT_LOCALE, LOCALE_CODES, type AppLocale } from './languages'

import en from './locales/en.json'
import lt from './locales/lt.json'
import de from './locales/de.json'
import fr from './locales/fr.json'
import es from './locales/es.json'
import pl from './locales/pl.json'
import ru from './locales/ru.json'
import pt from './locales/pt.json'
import it from './locales/it.json'
import nl from './locales/nl.json'
import uk from './locales/uk.json'

export type TranslationDict = Record<string, string>

const localeData: Record<AppLocale, TranslationDict> = {
  en: en as TranslationDict,
  lt: lt as TranslationDict,
  de: de as TranslationDict,
  fr: fr as TranslationDict,
  es: es as TranslationDict,
  pl: pl as TranslationDict,
  ru: ru as TranslationDict,
  pt: pt as TranslationDict,
  it: it as TranslationDict,
  nl: nl as TranslationDict,
  uk: uk as TranslationDict,
}

/** i18next `resources` shape for web. */
export function buildI18nextResources(): Record<string, { translation: TranslationDict }> {
  const out: Record<string, { translation: TranslationDict }> = {}
  for (const code of LOCALE_CODES) {
    out[code] = { translation: localeData[code] }
  }
  return out
}

export function getTranslation(locale: AppLocale, key: string): string {
  return localeData[locale]?.[key] ?? localeData.en[key] ?? key
}

export {
  APP_LOCALES,
  DEFAULT_LOCALE,
  LOCALE_CODES,
  localeMeta,
  isAppLocale,
  detectBrowserLocale,
  type AppLocale,
} from './languages'
export {
  currentPathWithLocale,
  ensureLocalePrefix,
  localeFromPathname,
  localeFromUrlSegment,
  localeRootPath,
  localeUrlSegment,
  pathWithLocale,
  readBrowserUrl,
  redirectLegacyUkLocalePath,
  replaceLocaleInUrl,
  stripLocalePrefix,
} from './localeUrl'
